// extracted by mini-css-extract-plugin
export default {"teachers":"StudentDetail_teachers__9wExw","logout":"StudentDetail_logout__pnUP4","logout-btn":"StudentDetail_logout-btn__6QaIB","h1":"StudentDetail_h1__w1F6M"};